import React from "react"
import types from "prop-types"
import { questionShape, taskShape } from "utils/propTypeShapes"
import TaskQuestion from "./TaskQuestion"

const TaskOpenGeneralTask = ({ generalTaskQuestion, task, taskControls }) => (
  <>
    <TaskQuestion
      className="w-full mb-6"
      question={generalTaskQuestion}
      task={task}
    />
    {taskControls}
  </>
)

TaskOpenGeneralTask.propTypes = {
  generalTaskQuestion: questionShape.isRequired,
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskOpenGeneralTask
